export default {
  perfil: {},
  perfis_list: [],
  categorias_list: [],
  loading: false,
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
